module.exports = __webpack_public_path__ + "a4063776dbf88df9f80579ddfcf59191.woff";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Medium.woff
// module id = 646
// module chunks = 0